import { createContext, useContext } from 'react';

// The SSR-safe "this page is rendering inside the app webview with its chrome hidden" flag, resolved
// once by PageLayout (server value + a post-mount client check) and read by page layouts that must
// drop their desktop scroll container in the webview. Defaults to false everywhere else.
const WebViewLayoutContext = createContext(false);

export const WebViewLayoutProvider = WebViewLayoutContext.Provider;

export const useIsWebViewLayout = (): boolean => useContext(WebViewLayoutContext);
